module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/DownloadedFile-6109b557c6f915199edb9928c76c341e.svg";